import axios from "axios";

export function tokenCall(tokenBody) {
    return axios.post(`${process.env.REACT_APP_AUTH_TOKEN_HOST_URL}/auth-tokens`, tokenBody);
}

